import { Component, ViewChild, ViewEncapsulation, Input, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { aggregateBy } from '@progress/kendo-data-query';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { InventoryQVBus } from '../../shared/models/InventoryQVBus';
import { DateFunctions } from '../../shared/static/date-functions';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { GItem } from '../../shared/models/GItem';
import { DispatchAddPartDialogComponent } from '../dispatch-add-part-dialog/dispatch-add-part-dialog.component';
import { DispatchPage } from '../../shared/models/DispatchPage';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { DispatchPartsBus } from '../../shared/models/DispatchPartsBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { v_DispatchPartsRequestedBus } from '../../shared/models/v_DispatchPartsRequestedBus';

@Component({
    selector: 'dispatch-qv-parts-requested',
    templateUrl: './dispatch-qv-parts-requested.component.html',
    styleUrls: ['./dispatch-qv-parts-requested.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchQVPartsRequestedComponent extends BaseGridEditLineComponent<v_DispatchPartsRequestedBus, null, DispatchesService>  {
    supplierNameCF: MSCLFilterClass;
    inventoryNumberCF: MSCLFilterClass;
    orderNumberCF: MSCLFilterClass;
    extraTechs: GItem[] = [];
    showMoveInventory: boolean = false;
    techId: string = null;
    @Input() dispatchPage: DispatchPage;
    curInventoryQVBus: InventoryQVBus;
    //@ViewChild('dispatchAddPartDialog') public dispatchAddPartDialog: DispatchAddPartDialogComponent;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "v_DispatchPartsRequestedBus";
        this.aggregates = [
            { field: 'amount', aggregate: 'sum' }
        ];
        this.state.group = [{ field: 'amount', aggregates: this.aggregates }];
        this.disableCpSearchDialog();
    }
    rowClassFunction(context: RowClassArgs) {
            if(context.dataItem.isAdded) {
                return { isAdded: true }
            }
            else if(context.dataItem.isUpdated) {
                return { isUpdated: true }
            }
            else if(context.dataItem.inFinance) {
                return { inFinance: true }
            }
    }
    
    //showAdd() {
    //    if (this.canAddEdit && this.dispatchPage && this.dispatchPage.dispatchTrucks && this.dispatchPage.dispatchTrucks.length > 0) { return true;}
    //    return false;
    //}
    //processGridData() {
    //    if (CommonFunctions.hasArrayElementValue(this.gridData)) {
    //        this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
    //        this.supplierNameCF = new MSCLFilterClass('supplierName', 'supplierName', this.gridData);
    //        this.inventoryNumberCF = new MSCLFilterClass('inventoryNumber', 'inventoryNumber', this.gridData);
    //        this.orderNumberCF = new MSCLFilterClass('orderNumber', 'orderNumber', this.gridData);
    //    }
    //}
    createForm() {
        this.editForm = new UntypedFormGroup({
            'id': new UntypedFormControl(),
            'usedPartQuantity': new UntypedFormControl(),

        });

    }
    setForm() {
        this.editForm.patchValue({
            id: this.selectedData.dispatchPartsRequestId,
            usedPartQuantity: this.selectedData.usedPartQuantity,
        });
    }
}
